// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7c99dc4","453":"0147867b","732":"6ddad37d"}[chunkId] + ".chunk.js";
};